import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectedLang, getMenu } from "../../../../actions";
import { addClass, getRouting, removeClass } from "../../../../../utils/common";
import "./style.scss";

const MobileNavbar = (props) => {
  useEffect(() => {
    getMenu();
  }, []);
  const { getMenus, commonContent } = props;

  const [leftMenu, setLeftMenu] = useState();
  useEffect(() => {
    if (getMenus !== undefined) {
      setLeftMenu(getMenus);
    }
  }, [commonContent]);

  // useEffect(() => {
  //   var size = parseInt($("p").css("font-size"));
  //   $(".smallText").on("click", function () {
  //     size -= 3;
  //     $("p").css("font-size", size + "px");
  //   });
  //   $(".mediumText").on("click", function () {
  //     size += 3;
  //     $("p").css("font-size", size + "px");
  //   });
  //   $(".desktopHamberger").click(function () {
  //     $(".megaMenu").addClass("showMegaMenu");
  //   });
  //   $(".closeMenu").click(function () {
  //     $(".megaMenu").removeClass("showMegaMenu");
  //   });
  //   $("body").click(function () {
  //     $(".megaMenu").removeClass("showMegaMenu");
  //   });
  //   $(".desktopHamberger").click(function (event) {
  //     event.stopPropagation();
  //   });
  //   $(".megaMenu").click(function (event) {
  //     event.stopPropagation();
  //   });

  //   $(".navbar-toggler").click(function () {
  //     $(".menu-overlay").addClass("left0");
  //     $(".navbar-collapse").addClass("show1");
  //     $("body").addClass("removeOverflow");
  //   });
  //   $(".menu-overlay").click(function () {
  //     $(".menu-overlay").removeClass("left0");
  //     $(".navbar-collapse").removeClass("show1");
  //     $("body").removeClass("removeOverflow");
  //   });

  //   $("body").click(function () {
  //     $(".moretext").removeClass("autoHeight");
  //   });
  //   $(".card").click(function (event) {
  //     event.stopPropagation();
  //   });
  // }, []);
  const handleCloseMobile = () => setShow(false);

  //mobileacord start
  const [selected, setSelected] = useState(null);
  const toggle = (index) => {
    if (selected === index) {
      return setSelected(null);
    }
    setSelected(index);
  };

  const [mobile, setMobile] = useState(null);
  const mobiletoggle = (childindex) => {
    if (mobile === childindex) {
      return setMobile(null);
    }
    setMobile(childindex);
  };
  //mobileacord end

  return (
    <div class="accordion mobileacord" id="accordionMobile">
      {leftMenu &&
        leftMenu.map((menu, index) =>
          menu && menu.childrens[0] === undefined ? (
            <div>
              {menu.linkUrl !== "/" ? (
                <a href={menu.linkUrl} target="_blank" className="menuitem">
                  {menu.linkName}
                </a>
              ) : (
                <Link
                  to={getRouting(menu.routeConstant)}
                  onClick={handleCloseMobile}
                  className="d-flex menuitem"
                >
                  {menu.linkName}
                </Link>
              )}
            </div>
          ) : (
            <>
              <div className="title px-0" onClick={() => toggle(index)}>
                <h2>{menu.linkName}</h2>
                <div>
                  <img
                    className={selected === index ? "rotate downarrows" : "downarrows"}
                    // src="/images/New/redDownArrow.svg"
                    src="/images/New/blue-arrowDown.svg"
                    alt="blue down arrow icon"
                    width={15}
                    height={15}
                  />
                </div>
              </div>
              <div
                className={selected === index ? "content show" : "content"}
              >
                <>
                  {menu &&
                    menu.childrens &&
                    menu.childrens.length > 0 &&
                    menu.childrens.map(
                      (childmenuData, childindex) =>
                        childmenuData &&
                        childmenuData.childrens &&
                        childmenuData.childrens.length > 0 &&
                        childmenuData.childrens.map(
                          (childmenu, childindex) => (
                            <div className={menu && menu.linkName == "Distributor Corner" ? "listmenu accordion mobileacorditems notapplied" : "listmenu accordion mobileacorditems"}>
                              {menu && menu.linkName !== "Distributor Corner" && childmenu &&
                              childmenu.childrens.length > 0 ? (
                                <>
                                  {/* <div
                                    className="title p-0"
                                    // onClick={() =>
                                    //   mobiletoggle(childindex)
                                    // }
                                  > */}
                                    <Link to={getRouting(childmenu.routeConstant)}
                                      onClick={handleCloseMobile} className="title p-0"
                                    >
                                      <p className="menutext">{childmenu.linkName}</p>
                                    </Link>
                                    {/* <div>
                                      <img
                                        className={
                                          mobile === childindex
                                            ? "rotate"
                                            : ""
                                        }
                                        src="/images/New/redDownArrow.svg"
                                        alt="red down arrow icon"
                                      />
                                    </div> */}
                                  {/* </div> */}
                                  <div
                                    className="accordchildd"
                                    // {
                                    //   mobile === childindex
                                    //     ? "content show"
                                    //     : "content"
                                    // }
                                  >
                                    <ul>
                                      {childmenu &&
                                        childmenu.childrens.length >
                                          0 &&
                                        childmenu.childrens.map(
                                          (subchilds, subchildindex) => (
                                            subchilds && subchilds.childrens && subchilds.childrens.length > 0 &&
                                            subchilds.childrens.map((subchild, subchildindex)=>(
                                              <li>
                                                {subchild.linkUrl !==
                                                "/" ? (
                                                  <a
                                                    href={
                                                      subchild.linkUrl
                                                    }
                                                    target="_blank"
                                                    className="d-flex"
                                                  >
                                                    {
                                                      subchild.attributes && subchild.attributes.class ?
                                                      <img src={subchild.attributes && subchild.attributes.class} alt={subchild.attributes && subchild.attributes.alt} className="me-2" width={22} height={22} loading="lazy"/>
                                                      : ""
                                                    }
                                                    <p>{subchild.linkName}</p>
                                                  </a>
                                                ) : (
                                                  <Link
                                                    to={getRouting(
                                                      subchild.routeConstant
                                                    )}
                                                    onClick={
                                                      handleCloseMobile
                                                    }
                                                  >
                                                    {subchild && subchild.linkName == "View all ->" ? 
                                                     <>
                                                     {/* <div className="d-flex"> */}
                                                      <a href={subchild && subchild.routeConstant} className="viewlinks d-flex align-items-center"> View all <img src="/images/New/Homepagestatic/md/arrow-blue.svg" alt="arrow image" className="ms-2" /></a>
                                                     {/* </div> */}
                                                     </>
                                                      : 
                                                      <div className="d-flex">
                                                        {
                                                          subchild.attributes && subchild.attributes.class ?
                                                          <img src={subchild.attributes && subchild.attributes.class} alt={subchild.attributes && subchild.attributes.alt} className="me-2" width={22} height={22} loading="lazy"/>
                                                          : ""
                                                        }
                                                        <p>{subchild.linkName}</p>
                                                      </div>
                                                    }
                                                  </Link>
                                                )}
                                              </li>
                                            )
                                          ))
                                        )}
                                    </ul>
                                  </div>
                                </>
                              ) : childmenu.linkUrl !== "/" ? (
                                // <div class="accordion mobileacorditems">
                                  <a
                                    href={childmenu.linkUrl}
                                    target="_blank"
                                    className="mobileacorditems"
                                  >
                                    <div className="d-flex listclass">
                                      {
                                        childmenu.attributes && childmenu.attributes.class ?
                                        <img src={childmenu.attributes && childmenu.attributes.class} className="me-2" width={22} height={22} alt={childmenu.attributes && childmenu.attributes.alt} loading="lazy"/>
                                        : ""
                                      }
                                      <p>{childmenu.linkName}</p>
                                    </div>
                                  </a>
                                // </div> 
                              ) : (
                                // <div class="accordion mobileacorditems">
                                  <Link
                                    to={getRouting(childmenu.routeConstant)}
                                    className="d-flex mobileacorditems"
                                    onClick={handleCloseMobile}
                                  >
                                    <div className="d-flex listclass">
                                      {
                                        childmenu.attributes && childmenu.attributes.class ?
                                        <img src={childmenu.attributes && childmenu.attributes.class} className="me-2" width={22} height={22} alt={childmenu.attributes && childmenu.attributes.alt} loading="lazy"/>
                                        : ""
                                      }
                                      <p>{childmenu.linkName}</p>
                                    </div>
                                  </Link>
                                // </div> 
                              )}
                            </div>
                          )
                        )
                    )}
                </>
              </div>
            </>
          )
        )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  commonContent: state.commonContent,
  getMenus: state.commonContent.menu.headerMenu,
});

const mapDispatchToProps = (dispatch) => ({
  getMenu: bindActionCreators(getMenu, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileNavbar);
